import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";
import { useState } from "react";

import { useDrillAssets } from "../../api/useDrillAssets";
import type { DrillSeries, DrillsOverview } from "../../model/Drill";
import { firstOpenIndex } from "../../model/seriesProgress";
import { DrillView } from "./DrillView";
import { SeriesHeader } from "./SeriesHeader";
import { SeriesResult } from "./SeriesResult";

const SAMPLE = msg({
  message:
    "Answers come from {matches, plural, one {# match} other {# matches}} of strong players on {hero} in 30 days. A topic you got wrong comes back tomorrow.",
});

type SeriesRunProps = { series: DrillSeries; overview: DrillsOverview };

// Серия по шагам: открывается на первой задаче без ответа; после ответа разбор остаётся
// на экране, пока игрок не нажмёт «Дальше». После последней — итог серии. На чём основан
// ответ — одной строкой внизу, а не под каждым разбором.
export const SeriesRun = ({ series, overview }: SeriesRunProps) => {
  const { i18n, t } = useLingui();
  const assets = useDrillAssets();
  const [step, setStep] = useState(() => firstOpenIndex(series.items));
  const item = series.items[step];
  if (item === undefined) {
    return <SeriesResult series={series} overview={overview} />;
  }
  return (
    <div className="flex flex-col gap-5">
      <SeriesHeader items={series.items} current={step} />
      <DrillView
        key={item.drill_id}
        item={item}
        isLast={step === series.items.length - 1}
        onNext={() => {
          setStep(step + 1);
          window.scrollTo({ top: 0 });
        }}
      />
      <p className="text-[13px] text-subtle">
        {item.spec.sample_size == null
          ? t`Answers come from your match. A topic you got wrong comes back tomorrow.`
          : i18n._({
              ...SAMPLE,
              values: {
                matches: item.spec.sample_size,
                hero: assets.hero(item.spec.hero_id).name,
              },
            })}
      </p>
    </div>
  );
};
